module.exports = __webpack_public_path__ + "static/media/switch-nocard.510b0b79.svg";